import { createFileRoute } from "@tanstack/react-router";
import {
  CustomIndustryServicePage,
  buildCustomIndustryServiceHead,
} from "@/components/CustomIndustryServicePage";
import { getCustomEntry } from "@/lib/customIndustryServiceData";

const ENTRY = getCustomEntry("web-design-for-hvac")!;

export const Route = createFileRoute("/web-design-for-hvac")({
  head: () => buildCustomIndustryServiceHead(ENTRY),
  component: () => <CustomIndustryServicePage entry={ENTRY} />,
});
